(() => {
  const previewTheme = document.currentScript?.dataset.previewThemeId || '';
  const allowedQuery = /^(q|type|sort_by|page|variant|preview_theme_id|preview_key|options\[prefix\]|filter\..+)$/;
  const prepareLocalization = form => {
    if (!(form instanceof HTMLFormElement) || !form.querySelector('[name="form_type"][value="localization"]')) return;
    const current = new URL(window.location.protocol === 'about:' ? document.baseURI : window.location.href);
    const path = current.pathname.replace(/^\/(?:uk|ru|en)(?=\/|$)/,'') || '/';
    const target = new URL(path, current.origin);
    current.searchParams.forEach((value,key) => { if (allowedQuery.test(key)) target.searchParams.append(key,value); });
    if (/^\d+$/.test(previewTheme)) target.searchParams.set('preview_theme_id',previewTheme);
    let input = form.querySelector('[name="return_to"]');
    if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = 'return_to'; form.append(input); }
    input.value = target.pathname + target.search;
  };
  const prepareForms = () => document.querySelectorAll('form[action*="/localization"]').forEach(prepareLocalization);
  prepareForms();
  document.addEventListener('submit', event => prepareLocalization(event.target),true);
  document.addEventListener('change', event => {
    const form = event.target.closest?.('form[action*="/localization"]');
    if (form) prepareLocalization(form);
  },true);
  document.addEventListener('shopify:section:load',prepareForms);
  document.addEventListener('click',event => {
    document.querySelectorAll('.ls-language-picker[open]').forEach(picker => {
      if (!picker.contains(event.target)) picker.open = false;
    });
  });
  document.addEventListener('keydown',event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.ls-language-picker[open]').forEach(picker => {
      picker.open = false;
      picker.querySelector('summary')?.focus();
    });
  });
  let frame = 0;
  const viewport = () => {
    frame = 0;
    const height = Math.round(window.visualViewport?.height || window.innerHeight);
    document.documentElement.style.setProperty('--ls-viewport-height',height + 'px');
  };
  const queueViewport = () => { if (!frame) frame = requestAnimationFrame(viewport); };
  viewport();
  window.visualViewport?.addEventListener('resize',queueViewport,{passive:true});
  window.addEventListener('resize',queueViewport,{passive:true});
  window.addEventListener('pageshow',event => {
    prepareForms();
    viewport();
    if (event.persisted) {
      document.querySelectorAll('.menu-drawer-container[open]').forEach(details => {
        const close = details.querySelector('.ls-menu-toolbar .menu-drawer__close-button');
        close?.click();
      });
    }
  });
})();